<template>
  <div class="border p-3">
  <h6 class="font-weight-bold">Important Notes</h6>
  <div v-if="termsDetails.policicies.cancellation_policy">
    <p class="font-weight-bold pt-3">Cancelation policies</p>
    <p class="text-sm" v-html="this.termsDetails.policicies.cancellation_policy"></p>
  </div>
  <p class="font-weight-bold">Terms and Conditions</p>
  <p class="text-sm" v-html="this.termsDetails.policicies.hostel_conditions"></p>
  <div v-if="termsDetails.policicies.child_policy">
    <span class="font-weight-bold">Child Policy : </span>
    <p v-html="this.termsDetails.policicies.child_policy"></p>
  </div>
  </div>
</template>

<script>
export default {
  computed: {
    termsDetails () {
      const allData = this.$store.getters.bookingDetails
      const sortedData = {
        reference: allData.reference_number,
        policicies: {
          'child_policy': allData.hostelchildpolicies,
          'cancellation_policy': allData.cancellation_policy,
          'hostel_conditions': allData.hostelconditions
        }
      }
      return sortedData
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/manageBooking/subcomponents/Terms.vue